import React from "react"
import { Box } from "@indeed/ifl-components"
import { StyleProps } from "@indeed/ifl-components/src/utils/styled"

/**
 * StickyBox, a wrapper of the Box component which will stick to the
 * bottom of the screen regardless of the client scroll position
 *
 * Sets a container box that is fixed and anchored to the bottom-left of the screen.
 * Fixed elements are ignored by relative layout, so we must set a relative
 * "phantom box" to reserve the sticky box's position
 *
 * Possible future enhancements
 *   Use height prop as a suggestion and get actual height of component children in componentDidMount()
 *   Add support for sticking to the top of the screen (probably not useful for our app)
 *
 * @param props.blockSize Anticipated blockSize (height) of the child component
 * @param props.sx Styles to pass-through to the Box container
 */
export const StickyBox: React.FC<{ blockSize: string; sx?: StyleProps["sx"]; id?: string; children?: React.ReactNode }> = (props) => {
    const { blockSize, sx, id, children } = props
    return (
        <Box sx={{ blockSize }}>
            <Box
                id={id}
                sx={{
                    position: "fixed",
                    insetBlockEnd: "0",
                    insetInlineStart: "0",
                    // Upside down copy of aurora.shadows.low
                    boxShadow:
                        "0 -0.125rem 0.25rem rgb(45 45 45 / 12%), " +
                        "0 -0.0625rem 0.1875rem rgb(45 45 45 / 16%), " +
                        "0 0 0.125rem rgb(45 45 45 / 20%);",
                    backgroundColor: "background.weaker",
                    ...sx,
                }}
            >
                {children}
            </Box>
        </Box>
    )
}
